<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
      <el-tag
        class="fm-margin-left-10"
        :type="$jsTool.getOrderApprovalStatusType(head.orderApprovalStatusEnum)"
        >{{ head.orderApprovalStatusEnum.Desc }}</el-tag
      >
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="客户">
      {{ head.customer.customerNo }}<br />
      {{ head.customer.name }}
    </el-descriptions-item>
    <el-descriptions-item label="联系人信息" span="2">
      {{ head.customerName + " " + head.customerPhoneNumber }}
      <br />
      {{ "联系地址：" + head.customerAddress }}
    </el-descriptions-item>
    <el-descriptions-item label="关联销售单" span="3">
      {{ head.relatedSaleOrderHead.orderNo }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="300px"
        style="max-width: 750px"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          sortable
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="商品图片"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              :commodity="scope.row.relatedSaleOrderItem.commoditySnapshot"
              :commoditySpec="
                scope.row.relatedSaleOrderItem.commoditySpecSnapshot
              "
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commoditySnapshot.name"
          label="商品信息"
          min-width="150"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <span style="font-size: 1.1em">{{
                scope.row.relatedSaleOrderItem.commoditySnapshot.name
              }}</span
              ><br />
              {{
                "规格：" +
                scope.row.relatedSaleOrderItem.commoditySpecSnapshot.specName
              }}<br />
              {{
                "分类：" +
                scope.row.relatedSaleOrderItem.commoditySnapshot
                  .commodityCategory.name
              }}<br />
              {{
                "颜色：" +
                scope.row.relatedSaleOrderItem.commoditySnapshot.color
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="relatedSaleOrderItem.buyingPrice"
          label="商品零售价"
          width="120"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount
              :amount="
                scope.row.relatedSaleOrderItem.buyingPrice
              "
            ></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="退货数量"
          width="100"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.itemQuantity +
              scope.row.relatedSaleOrderItem.commoditySnapshot.unit
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityBuyingTotalAmount"
          label="总零售价"
          width="120"
          align="center"
          header-align="center"
          sortable
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.commodityBuyingTotalAmount"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="入库进度"
          width="150"
          align="left"
          header-align="center"
          v-if="head.orderApprovalStatusEnum.Name == 'Approval'"
        >
          <template slot-scope="scope">
            {{ "待入库 " + scope.row.toBeInputQuantity }}<br />
            {{ "入库中 " + scope.row.inputingQuantity }}<br />
            {{ "已入库 " + scope.row.completedInputQuantity }}
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item span="1">
      <el-tooltip slot="label" placement="top">
        <div slot="content" style="line-height: 1.5em;" v-html="$jsTool.shippedMarkText()"></div>
        <span>
          <i class="el-icon-question"></i>
          发货标识
        </span>
      </el-tooltip>
      <span v-fmtype="head.shippedMark ? 'success' : 'warning'">{{
        head.shippedMark ? "已发货" : "未发货"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item span="2">
      <el-tooltip slot="label" placement="top">
        <div slot="content" style="line-height: 1.5em;" v-html="$jsTool.collectedMarkText()"></div>
        <span>
          <i class="el-icon-question"></i>
          收款标识
        </span>
      </el-tooltip>
      <span v-fmtype="head.collectedMark ? 'success' : 'warning'">{{
        head.collectedMark ? "已收款" : "未收款"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总零售价：
        <FmAmount :amount="head.commodityBuyingTotalAmount"></FmAmount>
        ）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="付款进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          付款进度：
          <span
            v-fmtype="$jsTool.getFundPayProgressType(head.fundPayProgressEnum)"
          >
            {{ head.fundPayProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">
          待付：<FmAmount :amount="head.toBePayAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          付款中：<FmAmount :amount="head.payingAmount"></FmAmount
          >，已付款：<FmAmount :amount="head.completedPayAmount"></FmAmount
          >，付款优惠：<FmAmount :amount="head.payDisCountAmount"></FmAmount>
        </div>
        <div class="fm-flex">
          全部付款时间：<span v-fmtype="head.fullPayTime ? '' : 'warning'">{{
            head.fullPayTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="入库进度" span="2">
      <div v-if="head.orderApprovalStatusEnum.Name == 'Approval'">
        <div class="fm-flex">
          入库进度：
          <span
            v-fmtype="
              $jsTool.getCommodityInputProgressType(
                head.commodityInputProgressEnum
              )
            "
          >
            {{ head.commodityInputProgressEnum.Desc }}
          </span>
        </div>
        <div class="fm-flex">待入库：{{ head.toBeInputQuantity }}</div>
        <div class="fm-flex">
          入库中：{{ head.inputingQuantity }}，已入库：{{
            head.completedInputQuantity
          }}
        </div>
        <div class="fm-flex">
          全部入库时间：<span v-fmtype="head.fullInputTime ? '' : 'warning'">{{
            head.fullInputTime || "暂无"
          }}</span>
        </div>
      </div>
      <span v-fmtype="'warning'" v-else>——</span>
    </el-descriptions-item>
    <el-descriptions-item label="业务员" span="3">
      {{ head.saleUserList.map((d) => d.user.name).join("、") }}
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="流程信息" span="3">
      <OrderStep :orderInfo="head" :displayTime="displayTime"></OrderStep>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleReturnOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = newVal;
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.head
        ? this.showOrderInfo.head
        : {};
    },
    itemList() {
      return this.showOrderInfo && this.showOrderInfo.itemList
        ? this.showOrderInfo.itemList
        : [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      needApproval: true,
      displayTime: true,
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:SaleReturnOrder:NeedApproval",
        "Order:SaleReturnOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleReturnOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.needApproval = false;
        }
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleReturnOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.saleReturnOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/SaleReturnOrderInfo.vue